import React, { useState } from "react";
import Modal from 'react-modal';
import GoogleMapReact from 'google-map-react';
import { googleApiKey } from '../../environment';
import { customStylesModal } from '../shared/selectStyle';
import './style.css';

const markerGoogle = {
  position: 'absolute',
  width: '40px',
  height: '40px',
  left: '-20px',
  top: '-40px'
}


const Marker = (props) => {
  return (
    <img style={markerGoogle} src="/assets/images/marker.png" alt="location" />
  )
}
const GoogleMap = (props) => {
  return (
    <div style={{ height: '600px', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: googleApiKey }}
        center={{ lat: props.lat, lng: props.lon }}
        defaultZoom={14}
        yesIWantToUseGoogleMapApiInternals
        className="google-wrapper-map"
      >
        <Marker
          lat={props.lat}
          lng={props.lon}
        />
      </GoogleMapReact>
    </div>
  )
}


const ModalMap = (props) => {
  const [modalIsOpen] = useState(props.show);
  const [lon] = useState(props.cordinates[0]);
  const [lat] = useState(props.cordinates[1]);
  const [address] = useState(props.address);

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={props.closeModal}
      style={customStylesModal}
      contentLabel="Custom modal"
      ariaHideApp={false}
      className="custom-modal map-modal"
    >
      <div className="modal-header">
        <div className="modal-close"><i className="fa fa-times-circle" aria-hidden="true" onClick={props.closeModal}></i></div>
        <h5>{address}</h5>
      </div>
      <div className="modal-body">
        <GoogleMap address={address} lon={lon} lat={lat} />
      </div>
    </Modal>
  );
}

export default ModalMap;


// WEBPACK FOOTER //
// ./src/components/foldersComponent/modalMap.js